import { Component, Input, OnInit } from '@angular/core';
import { INavigationItem } from 'app/_models/INavigationItem';
import { CommunicationService } from 'app/_services/communication.service';
import { MenuService } from 'app/_services/menu.service';
import { AppComponent } from 'app/app.component';
import { IconDefinition, faCircleNotch, faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { ISettings } from 'app/_models/ISettings';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {
  //#region Fields & Icons 
  @Input() settings: ISettings;
  @Input() item: INavigationItem;  //parent menu
  @Input() userId: string;
  @Input() pathList: any;
  items: INavigationItem[] = [];  //its children
  itemToReselect: string;  
  faCircleNotch: IconDefinition = faCircleNotch;
  faChevronDown: IconDefinition = faChevronDown;
  faChevronRight: IconDefinition = faChevronRight;
  //#endregion

  constructor(
    private app: AppComponent,
    private communicationService: CommunicationService,
    private menuService: MenuService
  ) {
    this.communicationService.base_menu_reloadMenuFromDirect$.subscribe((itemId: string) => {
      this.itemToReselect = itemId;
      localStorage.removeItem('qx_directFromExisting');
      this.loadMenu();
    });
  }

  ngOnInit(): void {
    if (localStorage.getItem('qx_directFromExisting')) return;
    this.loadMenu();
  }

  loadMenu(): void {
    this.getMenu().then(menuItems => {
      this.items = menuItems;
      if (this.pathList && this.pathList.length > 0) {
        for (let i = 0; i < this.pathList.length; i++) {
          if (!this.pathList[i].loaded) {
            this.pathList[i].loaded = true;
            let item = this.items.find(item => item.id == this.pathList[i].id);
            if (item) {
              this.getView(item, null);
              return;
            }
          }
        }
      }
    });
  }

  getMenu(): Promise<INavigationItem[]> {
    return new Promise<INavigationItem[]>((resolve) => {
      let menuItems = [];
      let id = this.item == undefined ? -1 : this.item.id;
      let formData = this.app.buildForm(['userId', 'id', 'idToReselect'], [this.userId.toString(), id.toString(), this.itemToReselect ? this.itemToReselect : '']);
      this.menuService.getMenu(formData).subscribe({
        next: (data: { result: INavigationItem[], pathList: string }) => {
          if (data) {
            menuItems = data.result;
            menuItems.forEach(menu => {
              menu.expanded = false;
              menu.selected = false;
              if (menu.viewType == 'MasterDetailView' || menu.viewType == 'GanttView' || menu.viewType == 'MapView') {
                menu.link = `/direct?enabledirect=false&view=${menu.id}`;
              }

              if (menu.imageIcon && menu.imageIcon.charAt(0) == 'i')
                menu.imageIcon = this.app.domSanitizer.bypassSecurityTrustUrl(`data:image/png;base64, ${menu.imageIcon}`);
              else if (menu.imageIcon && menu.imageIcon.charAt(0) == '/')
                menu.imageIcon = this.app.domSanitizer.bypassSecurityTrustUrl(`data:image/jpeg;base64, ${menu.imageIcon}`);
              else menu.imageIcon = '';
            });

            if (data.pathList.length > 0) this.pathList = data.pathList;
          }

          resolve(menuItems);
        }, error: (errorLog) => { console.log(errorLog); }
      });
    });
  }

  getView(item: INavigationItem, event: any): void {
    if (event) event.preventDefault();
    this.items.forEach(item => { item.selected = false; });
    item.selected = true;
    item.expanded = !item.expanded;
    if (item.viewType == 'MasterDetailView') {
      sessionStorage.setItem('nodeId', item.id.toString());
      sessionStorage.setItem('nodeName', item.name);
      this.app.showLoader();
      this.communicationService.loadRadButtons(item.name, item.id.toString());
      this.communicationService.loadGridView(item.id.toString(), item.name);
      this.communicationService.updateOpenMenu(item);
    }

    if (item.viewType == 'GanttView') {
      sessionStorage.setItem('nodeId', item.id.toString());
      sessionStorage.setItem('nodeName', item.name);
      this.app.showLoader();
      this.communicationService.loadRadButtons(item.name, item.id.toString());
      this.communicationService.loadGanttView(item.id.toString());
      this.communicationService.updateOpenMenu(item);
    }

    if (item.viewType == 'MapView') {
      sessionStorage.setItem('nodeId', item.id.toString());
      sessionStorage.setItem('nodeName', item.name);
      this.app.showLoader();
      this.communicationService.loadRadButtons(item.name, item.id.toString());
      this.communicationService.loadMapView(item.id.toString());
      this.communicationService.updateOpenMenu(item);
    }
  }
}